import { readUploadFacadeErrorCode } from "./uploadFacadeErrors";

export const UPLOAD_VERIFICATION_RECHECK_MS = 2_000;
const VERIFICATION_PENDING_CODE = "UPLOAD_VERIFICATION_PENDING";

/** Expected object/root verification delay; no transfer or failure attempt needs repeating. */
export function isUploadVerificationPending(value: unknown): boolean {
	return typeof value === "string"
		? value.startsWith(`${VERIFICATION_PENDING_CODE}:`)
		: readUploadFacadeErrorCode(value) === VERIFICATION_PENDING_CODE;
}

export function verificationPendingRetryOptions(session: { retryAttempt?: number }, now: number): { retryAt: number; retryAttempt: number } {
	return { retryAt: now + UPLOAD_VERIFICATION_RECHECK_MS, retryAttempt: session.retryAttempt ?? 0 };
}
